import React from 'react';
import { ShowSummaryModal } from './show-summary-modal.component';
import { useShowSummaryModalService } from './show-summary-modal.service';
import type { ShowSummaryModalContainerProps } from './show-summary-modal.types';

export const ShowSummaryModalContainer = (
  props: ShowSummaryModalContainerProps,
) => {
  const serviceProps = useShowSummaryModalService(props);
  return <ShowSummaryModal {...serviceProps} />;
};
